import type {
  fetchMutationKey,
  resources
} from "@dealer-center/ddc-pages-resources-interface";
import axios from "axios";
import { getResourcesUrlToUse } from "./helper";

const baseUrl = "/landing/nxlambda/resources/";

export const fetchResourcesGet = async (account?: string) => {
  if (!account) {
    return [];
  }
  const url = getResourcesUrlToUse(account);
  const fetchResult = await fetch(url);
  return (await fetchResult.json()) as resources[];
};

export const fetchResourceUpdate = (
  fetchMutation: fetchMutationKey
): Promise<string[]> =>
  axios
    .post(
      `${baseUrl}${fetchMutation.accountId}/updateResource`,
      fetchMutation.resources
    )
    .then(res => res.data);

export const fetchResourceDelete = (
  fetchMutation: fetchMutationKey
): Promise<string[]> =>
  axios
    .post(
      `${baseUrl}${fetchMutation.accountId}/deleteResource`,
      fetchMutation.resources
    )
    .then(res => res.data);
